// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".SimpleLayout{min-height:100vh;background-image:url(/assets/images/Constellation-grid.webp);image-rendering:optimizeQuality;background-size:cover;background-repeat:no-repeat;background-position:50%}.SimpleLayout.noBackground{background-image:none}.SimpleLayout .HeaderLine{height:60px;width:100%}\n", ""]);
// Exports
module.exports = exports;
